"use strict";

//
// EVCalculator.js
// Javascript version of curve plotting calculator.
//

import EVDatafile from "./EVDataFile";
import EVSpline from "./EVSpline";
import EVFMDCalculator from "./EVFMDCalculator";
import {roundf} from "../../js-utilities";

const kFemaleSmokingFilepath = "/curves/female_smoking.json";
const kMaleSmokingFilepath = "/curves/male_smoking.json";

//
//
//

export default class EVCalculator {
    constructor(version) {
        this.version = version;
        this.datafiles = {};
        this.initialized = false;
        this.pendingDownloads = 0;
        this.allRequestsSent = false;
        this.listener = undefined;
    }

    //
//
//

    init() {
        // Get all the datafiles.
        const datafiles = [
            kFemaleSmokingFilepath,
            kMaleSmokingFilepath,
        ];

        for (let i = 0; i < datafiles.length; i++) {
            const currentDatafile = "../VAC_4" + datafiles[i];
            $.get(currentDatafile, this.callback_handler(this, this.addDatafile), 'json');
            this.pendingDownloads++;
        }
        this.allRequestsSent = true;

    };

//
//
//

    addDatafile(response) {
        const datafile = new EVDatafile(response);
        this.datafiles[datafile.dataType + "_" + datafile.gender] = datafile;
        this.pendingDownloads--;
        if (this.allRequestsSent && this.pendingDownloads === 0) {
            this.initialized = true;
        }
    };

//
//
//

    callback_handler(context, handler) {
        return function (response) {
            handler.call(context, response);
        };
    };


//
//
//

    interpolatedDatasetForType(data_type, gender) {
        const key = data_type + "_" + (gender === 0 ? "male" : "female");
        const datafile = this.datafiles[key];

        console.log('EVSpline', 'interpolatedDatasetForType', 'data_type', data_type, 'gender', gender, 'key', key, 'datafile', datafile);
        const spline = new EVSpline(datafile.values, 11);

        // Copy the datafile and add interpolated set of points to plot.
        const interpolatedDataFile = new EVDatafile(JSON.parse(datafile.toJSON()));
        interpolatedDataFile.values = spline.interpolatedPoints(100);

        return interpolatedDataFile;
    };

//
//
//

    riskForValue(data_type, value, age, gender) {
        const datapoint = {
            data_type: data_type,
            value: value,
            age: age,
            gender: gender
        };

        if (data_type === "fmd") {
            // FMD returns age changes - calculate a Framingham risk equivalent.
            // const fmdCalculator = new EVFMDCalculator();
            // This wasn't being used when I found it, not going to mess with it
            // var ageChange = fmdCalculator.ageChangeFromFMD(value, age, gender);
            datapoint.risk = value / 1.7;
        } else {
            const key = data_type + "_" + (gender === 0 ? "male" : "female");
            const datafile = this.datafiles[key];

            console.log('EVSpline', 'riskForValue', 'data_type', data_type, 'value', value, 'age', age, 'gender', gender, 'key', key, 'datafile', datafile);
            const spline = new EVSpline(datafile.values, 11);

            datapoint.risk = spline.getY(value);
        }

        return datapoint;
    };

//
//
//

    ageChangeForValue(data_type, value, age, gender) {
        const response = {
            data_type: data_type,
            value: value,
            age: age,
            gender: gender,
            age_change: 0
        };

        if (data_type === "fmd") {
            // FMD returns age changes directly.
            const fmdCalculator = new EVFMDCalculator();
            response.age_change = fmdCalculator.ageChangeFromFMD(value, age);
        } else if (data_type === "underlying_kidney") {
            if (value !== undefined) {
                response.age_change = 58;
            } else {
                response.age_change = 0;
            }
        } else if (data_type === "waist") {
            // male
            if (gender === 0) {
                response.age_change = (.001503268 * (value ** 2) - (.1481699346 * value) + 1.279738562);
            }
            // female
            else {
                response.age_change = (.0011623932 * (value ** 2) - (.0652991453 * value) - 1.641025641);
            }
        } else if (data_type === "bp") {
            // male
            if (gender === 0) {
                response.age_change = 11 / (1 + Math.exp(-.09 * (value - 121))) - 5.3;
            }
            // female
            else {
                response.age_change = 16.8 / (1 + Math.exp(-.09 * (value - 125))) - 6.8;
            }
        } else if (data_type === "bpt") {
            // male
            if (gender === 0) {
                response.age_change = 10.4 / (1 + Math.exp(-.09 * (value - 140))) - .5;
            }
            // female
            else {
                response.age_change = 15 / (1 + Math.exp(-.09 * (value - 140))) - 2;
            }
        } else if (data_type === "bmi") {
            response.age_change = (.0107364123 * (value ** 2) - (.1534602929 * value) - 2.835521684);
        } else if (data_type === "a1c") {
            response.age_change = (23 / (1 + Math.exp(-2 * (value - 6.7))) - 3);
        } else {
            const key = data_type + "_" + (gender === 0 ? "male" : "female");
            const datafile = this.datafiles[key];
            if (datafile && datafile.values) {
                // console.log('EVSpline', 'ageChangeForValue', 'data_type', data_type, 'value', value, 'age', age, 'gender', gender, 'key', key, 'datafile', datafile);
                const spline = new EVSpline(datafile.values, 11);
                const risk = spline.getY(value);
                response.age_change = this.ageChangeFromCVDRisk(risk);
            }
        }

        // Update this file to use imports so we can use roundf here
        response.age_change = roundf(response.age_change, 6);
        window.ageChanges = window.ageChanges ? window.ageChanges : {};
        window.ageChanges[data_type] = response.age_change;

        return response;
    };

    ageChangeForVitaminD(vitamin_d, units, age, gender) {
        const response = {
            vitamin_d: vitamin_d,
            units: units,
            age: age,
            gender: gender,
            age_change: 0
        };


        if (vitamin_d !== undefined) {

            /*
             *  y = 64.214 - 3.507X + 0.047X^2
             *  y = change in CovidAge (years)
             *  x = vitamin D concentration
             *  if units is nmol/L - divide final value by 2.5
             */
            //console.log(vitamin_d + "-" + units);

            let x = vitamin_d;

            if (units === "si") {
                x = Math.round(x / 2.5);

            } else {

            }

            response.age_change = 64.214 - (3.507 * x) + (0.047 * (x ** 2));

            //console.log(ageChange);
        }

        // Update this file to use imports so we can use roundf here
        response.age_change = roundf(response.age_change, 6);
        window.ageChanges = window.ageChanges ? window.ageChanges : {};
        window.ageChanges.vitamin_d = response.age_change;

        return response;
    }

    ageChangeForLipids(tg, hdlc, units, age, gender) {
        const response = {
            tg: tg,
            hdlc: hdlc,
            units: units,
            age: age,
            gender: gender,
            age_change: 0
        };

        if (tg !== undefined && hdlc !== undefined) {

            /*
             *  y = 24.5 / (1 + Math.exp(-.1724 * x)) - 14.85
             *  y = change in CovidAge (years)
             *  x = the ratio of TG/HDL-C in mg/dl units
             *  if units is mmol/L - multilpy ratio (x) by 2.29
             */
            //console.log(tg + "-" + hdlc + "-" + units);

            let x = tg / hdlc;

            if (units === "si") {
                x = x * 2.29;
            }

            response.age_change = 24.5 / (1 + Math.exp(-.1724 * x)) - 14.85;

            //ageChange = 1;
            //console.log(ageChange);
        }

        // Update this file to use imports so we can use roundf here
        response.age_change = roundf(response.age_change, 6);
        window.ageChanges = window.ageChanges ? window.ageChanges : {};
        window.ageChanges.lipids = response.age_change;

        return response;
    }


    ageChangeForUnderlying(value1, value2, value3, value4, age, gender) {
        const response = {
            value1: value1,
            value2: value2,
            value3: value3,
            value4: value4,
            age: age,
            gender: gender,
            age_change: 0
        };

        // CKD
        if (value1) {
            // was +58
            response.age_change += 41 - (.34 * age);
        }
        // CARDIO
        if (value2) {
            // was +49
            response.age_change += 34.16 - (.28 * age);
        }
        // CLD
        if (value3) {
            // was +31
            response.age_change += 21.96 - (.18 * age);
        }
        // IMMUNO
        if (value4) {
            // was +34
            response.age_change += 24.4 - (.20 * age);
        }

        // Update this file to use imports so we can use roundf here
        response.age_change = roundf(response.age_change, 6);
        window.ageChanges = window.ageChanges ? window.ageChanges : {};
        window.ageChanges.underlying = response.age_change;

        return response;
    };

//
//
//

    ageChangeFromCVDRisk(points) {
        // V 2.0 note: Adding the constant to the age shift means a score of 0 points returns .71 years of added vascular age.
        //
        // V3.1 note: Since version 2.0, we've been using Ramses' risk to age change conversion factor of 1.7.
        // However, based on Peter's work, a 4 point increase in risk correlates to a 10 year increase in vascular age,
        // resulting in a conversion factor of 2.5.

        //		return 1.7 * ($points); //  + 0.71;

        let ageChange;

        const vac_public = true;

        if (vac_public === true) {
            ageChange = 1.7 * points;
        } else {
            ageChange = 2.5 * points;
        }

        // Update this file to use imports so we can use roundf here
        ageChange = roundf(ageChange, 6);
        return ageChange;
    };

}
